import { useEffect } from "react";
import Lenis from "lenis";
import { useLocation } from "react-router-dom";

export const lenisRef = { current: null };

export const SmoothScroll = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    lenisRef.current = lenis;
    let frame;
    const raf = (t) => {
      lenis.raf(t);
      frame = requestAnimationFrame(raf);
    };
    frame = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
      lenisRef.current = null;
    };
  }, []);

  useEffect(() => {
    if (lenisRef.current) lenisRef.current.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export const lockScroll = (locked) => {
  document.body.style.overflow = locked ? "hidden" : "";
  if (!lenisRef.current) return;
  if (locked) lenisRef.current.stop();
  else lenisRef.current.start();
};
